// extracted by mini-css-extract-plugin
module.exports =  {"enumeration__header":"EnumerationHeader-module__enumeration__header___p04p2","enumeration__title":"EnumerationHeader-module__enumeration__title___NX22W"};